var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import MediaController from '../MediaController';
import CenteredButton from '../CenteredButton';
import LoadingSpinner from '../LoadingSpinner';

import styles from './styles.less';

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.onLoadedMetadata = function () {
      _this.setState({
        mediadataLoaded: true
      });
    };

    _this.onCanPlay = function () {
      if (_this.$player.duration === Infinity) {
        // fix in which currentTime is set to a time long past the end of the clip (1 day should be safe)
        _this.$player.currentTime = 24 * 60 * 60;
      }
      _this.setState({
        ready: true
      });
    };

    _this.onTimeUpdate = function () {
      if (!_this.state.seeking) {
        _this.setState({
          elapsed: _this.$player.currentTime / _this.$player.duration
        });
      }
    };

    _this.onPlay = function () {
      _this.setState({
        playing: true
      });
    };

    _this.onPause = function () {
      _this.setState({
        playing: false
      });
    };

    _this.onEnded = function () {
      _this.setState({
        playing: false,
        elapsed: 0
      });
    };

    _this.onWaiting = function () {
      var waiting = _this.state.waiting;

      if (!waiting) {
        _this.setState({
          waiting: true
        });
      }
    };

    _this.onPlaying = function () {
      var waiting = _this.state.waiting;

      if (waiting) {
        _this.setState({
          waiting: false
        });
      }
    };

    _this.onSeekMouseDown = function () {
      _this.setState({ seeking: true });
    };

    _this.onSeekChange = function (e) {
      _this.setState({ elapsed: parseFloat(e.target.value) });
    };

    _this.onSeekMouseUp = function (e) {
      _this.setState({
        seeking: false
      });
      _this.$player.currentTime = parseFloat(e.target.value) * _this.$player.duration;
    };

    _this.setPlayingState = function (playState) {
      if (playState && _this.$player.paused) {
        _this.$player.play();
      } else {
        _this.$player.pause();
      }
    };

    _this.setToPosition = function (value) {
      _this.$player.currentTime = parseFloat(value);
    };

    _this.onClickResume = function (e) {
      e.persist();
      var playing = _this.state.playing;


      if (e.target !== _this.$controller && !playing) {
        _this.$player.play();
      }
    };

    _this.showMediaController = function () {
      var setHideTemplateMenu = _this.context.setHideTemplateMenu;


      setHideTemplateMenu && setHideTemplateMenu(false);

      _this.setState({
        hideMenu: false
      });
    };

    _this.hideMediaController = function () {
      var setHideTemplateMenu = _this.context.setHideTemplateMenu;


      setHideTemplateMenu && setHideTemplateMenu(true);
      _this.setState({
        hideMenu: true
      });
    };

    _this.state = {
      playing: false,
      elapsed: 0,
      mediadataLoaded: false,
      ready: false,
      hideMenu: true,
      waiting: false,
      source: props.src
    };

    _this.$player = null;
    _this.$controller = null;

    _this.durationOptions = [];
    return _this;
  }

  _createClass(Video, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var id = this.props.id;

      if (this.$player && (id !== nextProps.id || this.context.enteredAnswer !== null && nextContext.enteredAnswer === null)) {
        this.setState({
          playing: false,
          elapsed: 0,
          mediadataLoaded: false,
          ready: false,
          source: nextProps.src
        });
        this.$player.pause();
        this.$player.load();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var id = this.props.id;
      var _state = this.state,
          source = _state.source,
          waiting = _state.waiting;
      var _state2 = this.state,
          elapsed = _state2.elapsed,
          playing = _state2.playing,
          ready = _state2.ready,
          hideMenu = _state2.hideMenu,
          mediadataLoaded = _state2.mediadataLoaded;

      var showController = mediadataLoaded && !ready || ready;
      return React.createElement(
        'div',
        {
          className: styles.container,
          onMouseMove: this.showMediaController,
          onClick: this.showMediaController,
          role: 'button'
        },
        React.createElement(
          'div',
          { className: styles.videoAndControls },
          waiting && React.createElement(LoadingSpinner, null),
          React.createElement(
            'video',
            {
              className: styles.video,
              key: source,
              preload: 'auto',
              controls: false,
              controlsList: 'nodownload',
              autoPlay: false,
              onLoadedMetadata: this.onLoadedMetadata,
              onCanPlay: this.onCanPlay,
              onTimeUpdate: this.onTimeUpdate,
              onPlay: this.onPlay,
              onPause: this.onPause,
              onEnded: this.onEnded,
              onWaiting: this.onWaiting,
              onPlaying: this.onPlaying,
              ref: function ref(player) {
                _this2.$player = player;
              },
              playsinline: true // disable shitty native ios player for ios app
            },
            React.createElement('source', { src: source })
          ),
          showController ? React.createElement(
            Fragment,
            null,
            !playing && React.createElement(CenteredButton, {
              icon: 'icon-play',
              theme: 'tooltipRound',
              className: styles.resumeButton,
              onClick: this.onClickResume
            }),
            React.createElement(
              'div',
              {
                className: styles.mediaController + ' ' + (hideMenu ? styles.hidden : styles.show),
                onTransitionEnd: this.hideMediaController
              },
              React.createElement(MediaController, {
                ref: function ref(controller) {
                  _this2.$controller = controller;
                },
                id: id,
                playing: playing,
                elapsed: elapsed,
                duration: this.$player.duration,

                onSeekMouseDown: this.onSeekMouseDown,
                onSeekChange: this.onSeekChange,
                onSeekMouseUp: this.onSeekMouseUp,
                setPlayingState: this.setPlayingState,
                setToPosition: this.setToPosition
              })
            )
          ) : React.createElement(LoadingSpinner, null)
        )
      );
    }
  }]);

  return Video;
}(Component);

Video.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.number.isRequired,
  src: PropTypes.string
} : {};

Video.defaultProps = {
  src: null
};

Video.contextTypes = {
  setAnswer: PropTypes.func,
  setHideTemplateMenu: PropTypes.func,
  enteredAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
};

export default Video;